import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

import {
  IDevicesRequest,
  ILoginRequest,
  ISignOutRequest,
} from '../../../models/requests/UserRequests';
import {
  IDevicesResponse,
  ILogin,
  IProfile,
  ISignOutResponse,
} from '../../../models/response/UserResponse';
import { BaseQueryType } from '../../api';

export const postLogin = (build: EndpointBuilder<BaseQueryType, never, 'api'>) =>
  build.mutation<ILogin, ILoginRequest>({
    query: (body) => ({
      url: 'v1/inspector/login/',
      body,
      method: 'POST',
    }),
  });

export const fetchProfile = (build: EndpointBuilder<BaseQueryType, never, 'api'>) =>
  build.query<IProfile, void>({
    query: () => `v1/inspector/me/`,
  });

export const setDevice = (build: EndpointBuilder<BaseQueryType, any, 'api'>) =>
  build.mutation<IDevicesResponse, IDevicesRequest>({
    query: (body) => ({
      url: 'v1/devices/',
      body,
      method: 'POST',
    }),
  });

export const setSignOut = (build: EndpointBuilder<BaseQueryType, any, 'api'>) =>
  build.mutation<ISignOutResponse, ISignOutRequest>({
    query: (body) => ({
      url: 'v1/inspector/logout/',
      body,
      method: 'POST',
    }),
  });
